import {action, observable} from 'mobx';

import {BrowseCourse} from '@udemy/browse-course';
import {AvailableFiltersUnit, DiscoveryUnit} from '@udemy/discovery-api';

import {CardContainerUnit} from './card-container.mobx-store';

export class WindowShoppingUnitStore {
    @observable subUnits: CardContainerUnit[] = [];
    items: BrowseCourse[];

    constructor(unit: DiscoveryUnit) {
        this.items = unit.items as BrowseCourse[];
        if (unit?.available_filters?.units) {
            this.setUnits(unit.available_filters.units);
        }
    }

    @action
    setUnits = (skills: AvailableFiltersUnit[]) => {
        skills.forEach((skill, i) => {
            if (i === 0) {
                this.subUnits.push({...skill, items: this.items});
            } else {
                this.subUnits.push({...skill, items: []});
            }
        });
    };
}
